'use client'

import type { CmsBallLinkTrackerProps } from '@maestro/sanity-cms-blocks/blocks/cms-ball-links/cms-ball-links.types'

import { useCmsBallLinkTracker } from '@maestro/sanity-cms-blocks/blocks/cms-ball-links/batons/use-cms-ball-link-tracker'

export default function CmsBallLinkTracker(props: CmsBallLinkTrackerProps) {
  const { alt } = props
  const { ref } = useCmsBallLinkTracker(alt)

  return <span ref={ref} aria-hidden="true" style={{ display: 'none' }} />
}
